/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-throw-literal */
import {
  action,
  observable,
} from 'mobx';
import {
  isUndefined,
} from 'lodash';
import {
  RequestStatus,
} from 'mobx-store';
import {
  DeliveryRegionDTO,
} from '../../screens/deliveryRegionsScreen/DTOs/deliveryRegionDTO';
import {
  deliveryRegionsUrl,
  deliveryRegionById,
} from '../../axios/requests';
import Connections from '../../connections';
import {
  DeliveryRegionStoreInterface,
} from '../storeInterfaces/deliveryRegionStoreInterface';

export class DeliveryRegionStore implements DeliveryRegionStoreInterface {
  @observable currentDeliveryRegion: DeliveryRegionDTO;

  @observable deliveryRegionsList: DeliveryRegionDTO[] = [];

  @observable numberOfDeliveryRegions: number;

  @observable getDeliveryRegionsListRequestStatus: RequestStatus = RequestStatus.IDLE;

  @observable createOrUpdateStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getDeliveryRegionsList(): Promise<void> {
    try {
      this.getDeliveryRegionsListRequestStatus = RequestStatus.LOADING;

      const response = await Connections.wadiDeglaAxios.httpGet(deliveryRegionsUrl);

      this.deliveryRegionsList = response?.data[0];
      this.numberOfDeliveryRegions = response?.data[1];
      this.getDeliveryRegionsListRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getDeliveryRegionsListRequestStatus = RequestStatus.FAILED;
      console.error(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async getDeliveryRegionById(regionId: number): Promise<void> {
    try {
      this.createOrUpdateStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(deliveryRegionById(regionId));

      this.currentDeliveryRegion = response?.data;

      this.createOrUpdateStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.createOrUpdateStatus = RequestStatus.FAILED;
      console.error(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async createNewDeliveryRegion(newRegion: DeliveryRegionDTO): Promise<number> {
    try {
      this.createOrUpdateStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpPost(deliveryRegionsUrl, newRegion);
      this.createOrUpdateStatus = RequestStatus.SUCCESS;
      return response.data.newRegionId;
    } catch (error) {
      this.createOrUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action
  public async updateDeliveryRegionById(
    regionId: number, updatedDeliveryRegion: DeliveryRegionDTO, index?: number,
  ): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(deliveryRegionById(regionId), updatedDeliveryRegion);
      if (isUndefined(index)) {
        this.currentDeliveryRegion = updatedDeliveryRegion;
      } else {
        this.deliveryRegionsList[index] = updatedDeliveryRegion;
      }
    } catch (error) {
      console.error(error);
      throw Promise.reject(error);
    }
  }
}
